module.exports = __webpack_public_path__ + "img/ni.d518f58d.jpg";